import React from "react"

import {
  Box,
  Button,
  FormControl,
  FormHelperText,
  IconButton,
  Input,
  InputBaseComponentProps,
  InputLabel,
} from "@material-ui/core"
import { Clear as ClearIcon, Check as CheckIcon } from "@material-ui/icons"

export interface Props {
  id: string
  label?: React.ReactElement | string
  helpText?: React.ReactElement | string
  type?: string
  initialValue?: string
  disabled?: boolean
  minLength?: number
  maxLength?: number
  onValueSet: (value?: string) => void
}

const RemovableStringValueInput: React.FC<Props> = ({
  id,
  label,
  helpText,
  type = "text",
  initialValue,
  disabled,
  onValueSet,
  minLength,
  maxLength,
}) => {
  const [isSet, setIsSet] = React.useState(Boolean(initialValue))
  const [value, setValue] = React.useState(initialValue ?? "")

  const inputProps: InputBaseComponentProps = {}
  if (minLength) {
    inputProps.minLength = minLength
  }
  if (maxLength) {
    inputProps.maxLength = maxLength
  }

  const endAdornment = isSet ? (
    <IconButton
      data-qa-selector="remove"
      onClick={() => {
        setValue("")
        setIsSet(false)
        onValueSet(undefined)
      }}
    >
      <ClearIcon />
    </IconButton>
  ) : (
    value && (
      <IconButton data-qa-selector="submit" type="submit">
        <CheckIcon />
      </IconButton>
    )
  )

  return (
    <Box
      data-qa-selector={`${id}-form`}
      component="form"
      onSubmit={(ev) => {
        ev.preventDefault()
        setIsSet(true)
        onValueSet(value)
      }}
    >
      <FormControl>
        {label && <InputLabel>{label}</InputLabel>}
        <Input
          data-qa-selector="input"
          inputProps={inputProps}
          value={value}
          type={type}
          onChange={(ev) => setValue(ev.target.value)}
          endAdornment={endAdornment}
          disabled={isSet || disabled}
        />
        {helpText && <FormHelperText>{helpText}</FormHelperText>}
      </FormControl>
    </Box>
  )
}

export default RemovableStringValueInput
